import { withStyles } from '@material-ui/core'
import { Add } from '@material-ui/icons'
import { inject } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import PageTitle from '../../../../components/PageTitle/PageTitle'
import { Button } from '../../../../components/ui/Buttons'
import { findAllGuiaServicoModeloTGO } from '../../../../services/TGOService'
import { pageConfiguracoes } from '../../../../utils/getPageTitle'
import ListarModeloTGO from './ListarGuiaTGO'
import { observer } from 'mobx-react-lite'
import HeaderConfiguracoesButtonNovo from '../../Components/HeaderConfiguracoesButtonNovo'
import GuiaTGOModal from '../../../Atendimento/GuiaTGO/GuiaTGOModal'
import { TypeModalEnumTGO } from '../../../../stores/TGO.store'

const ModeloTGO = observer(({ classes, TGOStore }) => {
  const [paginaAtual, setPaginaAtual] = useState(0)
  const [last, setLast] = useState(false)
  const [modelosLoading, setModelosLoading] = useState(false)
  const [search, setSearch] = useState('')

  useEffect(() => {
    TGOStore.changeFieldsStore({
      pageNumberModelo: 0,
      searchNomeModelo: '',
      statusModelo: null,
      sortDirModelo: 'ASC',
      sortFieldModelo: 'nome',
      modelosConfig: [],
    })
    loadModelos()
  }, [])

  const loadModelos = () => {
    setModelosLoading(true)

    findAllGuiaServicoModeloTGO({
      search: TGOStore.searchNomeModelo || '',
      ativo: TGOStore.statusModelo,
      pageNumber: TGOStore.pageNumberModelo || 0,
      sortDir: TGOStore.sortDirModelo || 'ASC',
      sortField: TGOStore.sortFieldModelo || 'nome',
    })
      .then(response => {
        const {
          content,
          pageable: { pageNumber },
          last,
        } = response.data.data.findAllGuiaServicoModeloTGO

        setPaginaAtual(pageNumber)
        setLast(last)
        TGOStore.modelosConfig = [...TGOStore.modelosConfig, ...content]
      })
      .catch(() => {
        TGOStore.openNotification('Falha ao carregar a lista de modelos de TGO.', 'error')
      })
      .finally(() => {
        setModelosLoading(false)
      })
  }

  const handleClickNovoModelo = async () => {
    TGOStore.resetModelo()
    TGOStore.changeFieldsStore({
      isProntuario: false,
      typeModal: TypeModalEnumTGO.NOVO_MODELO_MODAL,
      openModal: true,
      sugestoesPagAtual: 0,
      sugestoes: [],
    })
  }

  const handleCloseModalNovoModelo = () => {
    TGOStore.changeFieldsStore({
      modelosConfig: [],
      pageNumberModelo: 0,
      openModal: false,
      tipoListagemSelecionada: 'sugestoes',
      idModeloSelecionado: '',
    })
    loadModelos()
  }

  const handleChangeStatusModelo = e => {
    TGOStore.changeFieldsStore({
      statusModelo: e.value,
      modelosConfig: [],
      pageNumberModelo: 0,
    })
    loadModelos()
  }

  const handleClickSearch = () => {
    TGOStore.searchNomeModelo = search
    TGOStore.changeFieldsStore({
      modelosConfig: [],
      pageNumberModelo: 0,
    })
    loadModelos()
  }

  const handleClickClear = () => {
    setSearch('')
    TGOStore.changeFieldsStore({
      searchNomeModelo: '',
      modelosConfig: [],
      pageNumberModelo: 0,
    })
    loadModelos()
  }

  const onChangeSearchNomeModelo = e => {
    setSearch(e.target.value)
  }

  const onKeypressSearchNomeModelo = e => {
    if (e.key === 'Enter' && search.length >= 3) {
      TGOStore.changeFieldsStore({
        searchNomeModelo: search,
        modelosConfig: [],
        pageNumberModelo: 0,
      })
      handleClickSearch()
    }
  }

  const status = [
    { name: 'Ativo', label: 'Ativo', value: true },
    { name: 'Inativo', label: 'Inativo', value: false },
  ]


  return (
    <>
      <div>
        <PageTitle title={pageConfiguracoes('Modelos Guia GTO')} />
        <HeaderConfiguracoesButtonNovo
          idPrefix="cfg-tgo"
          title="Guia GTO"
          labelButton="Novo Guia GTO"
          handleClickNovo={handleClickNovoModelo}
          showStatus
          status={{
            options: status,
            value: status[TGOStore.statusModelo],
            onChange: handleChangeStatusModelo,
          }}
          search={{
              handleChange: onChangeSearchNomeModelo,
              value: search,
              onKeypress: onKeypressSearchNomeModelo,
              handleClickClear: handleClickClear,
              onClickButtonSearch: handleClickSearch
          }}
        />
        <div className={classes.contentList}>
          <ListarModeloTGO
            loadModelos={loadModelos}
            paginaAtual={paginaAtual}
            last={last}
            modelosLoading={modelosLoading}
          />
        </div>
        <Button
          id="cfg-tgo-btn-nov"
          shadow
          shape='circle'
          bgColor='#26ACA9'
          onClick={handleClickNovoModelo}
          className={classes.buttonCriar}
        >
          <Add />
        </Button>
      </div>

      {TGOStore.openModal && (
        <GuiaTGOModal
          screen='Configurações'
          openModal={TGOStore.openModal}
          typeModal={TGOStore.typeModal}
          handleClose={handleCloseModalNovoModelo}
          loadModelos={loadModelos}
        />
      )}
    </>
  )
})

const styles = {
  headerProfile: {
    padding: '0 16px',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  contentList: {
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    padding: "24px 24px 0 24px",
    backgroundColor: "#F5F5F5",
    maxHeight: "800px",
    gap: "16px",
    "&> div": {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      height: "100%",
      overflowY: "auto",
      borderRadius: "16px",
      border: "solid 1px rgba(0, 0, 0, 0.1)",
      backgroundColor: "#FFF",
    },
  },
  buttonNovoModelo: {
    width: 152,
    height: 40,
    borderRadius: 87,
    boxShadow: 'none',
    background: '#F9BE73',
    color: '#fff',
    textTransform: 'capitalize',
    padding: '0 14px',
    marginLeft: 24,
    minWidth: 152,
    '@media (max-width: 1600px)': {
      width: 40,
      minWidth: 40,
      borderRadius: '100%',
    },
  },
  labelButtonNovoModelo: {
    marginLeft: '6px',
    '@media (max-width: 1600px)': {
      display: 'none',
    },
  },
  columnHeaderFiltro: {
    justifyContent: 'center',
    width: 70,
  },
  columnHeaderNome: {
    width: '50%',
  },
  columnHeaderItens: {
    width: '15%',
  },
  columnHeaderStatus: {
    width: '15%',
  },
  columnHeaderLabel: {
    display: 'flex',
    flexDirection: 'row',
    marginLeft: 20,
    alignItems: 'center',
  },
  arrowIcon: {
    display: 'flex',
    flexDirection: 'column',
  },
  filterButton: {
    width: 48,
    height: 48,
    background: '#fff',
    boxShadow: 'none',
    marginRight: 20,
  },
  inputRootSearch: {
    border: 'none',
  },
  inputSearch: {
    fontFamily: 'Poppins!important',
  },
  searchNomeModelo: {
    width: '100%',
    height: 48,
    borderRadius: '8px !important',
    border: 'none !important',
    background: '#F2F2F2',
    justifyContent: 'center',
    fontWeight: 400,
  },
  selectStatus: {
    width: 200,
    marginLeft: 16,
  },
  iconButtonSearch: {
    width: 30,
    height: 30,
  },
  gridSearch: {
    width: '100%',
    maxWidth: '582px',
  },
  buttonCriar: {
    position: 'absolute',
    bottom: 88,
    right: 37,
    zIndex: 100,
  },
}

const ModeloTGOWithStyles = withStyles(styles)(ModeloTGO)
export default inject('TGOStore')(ModeloTGOWithStyles)
